// extracted by mini-css-extract-plugin
export default {"container":"ContactInfo_container__yFo6o","icon":"ContactInfo_icon__qc9qm"};